import { render, staticRenderFns } from "./OfferMenu.vue?vue&type=template&id=65228888"
import script from "./OfferMenu.vue?vue&type=script&lang=js"
export * from "./OfferMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports